import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const Content = (props) => {
  return (
    <div className="c-personalizer__content-container c-list">
      <h1>Mat personaliseren</h1>
      <p>Stel hier gemakkelijk je mat samen en ontvang een vrijblijvende richtprijs.</p>
      <ul className="checked">
        <li><strong>Gratis</strong> digitale proefdruk</li>
        <li>Altijd <strong>gratis</strong> verzending</li>
        <li>Ontvang een <strong>offerte</strong> op maat</li>
        <li>Persoonlijk <strong>advies</strong></li>
        <li><strong>Maatwerk</strong> op de mm nauwkeurig</li>
      </ul>
    </div>
  )
}

export default Content



// WEBPACK FOOTER //
// ./src/js/personalizer/components/Content.js